import React, { Component } from "react";
import "./styles/index.scss";
import "./App.scss";
import BlankPage from "./routes/blank/";

class App extends Component {
  render() {
    return (
      <div className="App">
        <BlankPage />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js